import { authenticatedFetch } from './base'

/**
 * Get case data for a patient
 *
 * @param {number} id - patient ID
 * @param {number} caseId - case ID
 * @returns {*} - response with case data
 */
export const fetchCase = (id, caseId) => {
	let url = `/api/case/${id}`;

	if(caseId)
	{
		url+=`/${caseId}`
	}

	return authenticatedFetch(url, { method: 'get' })
		.then(function (response) {
			if (response.status === 200) {
				return response.json()
			} else if (response.redirectTo) {
				return response
			}
		})
		.then(function (cases) {
			return cases
		})
}

/**
 * Get list of cases for the current patient
 *
 * @returns {*} - response with list of cases
 */
export const fetchCases = () => {
    return authenticatedFetch(`/api/case/list`,
            {
                method: 'GET',
                headers: { 'content-type': 'application/json' }
            })
        .then(function(response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function(data) {
            return data
        })
}

/**
 * Set case as current for the patient portal
 *
 * @param {number} caseId - case ID
 * @returns {*} - HTTP 200 in case of success
 */
export const setSelectedCase = (caseId) => {
	return fetch(
		`/api/case/set/${caseId}`,
		{
			method: 'POST'
		}
	)
		.then(function (response) {
			return response.status === 200;
		})
}

/**
 * Submit survey answers
 *
 * @param {number} caseId - case ID
 * @param {number} protocolId - observational protocol ID
 * @param {number} instanceId - protocol instance ID
 * @param {number} surveyId - survey ID
 * @param {object} questionAnswerSides - AddBilateralAnswerModel model containing answers
 * @returns {*} - response containing next survey data if any
 */
export const submitSurvey = (
	caseId,
	protocolId,
	instanceId,
	surveyId,
	questionAnswerSides
) => {
	return authenticatedFetch(
		`/api/survey/${caseId}/${protocolId}/${instanceId}/${surveyId}`,
		{
			method: 'POST',
			headers: { 'content-type': 'application/json' },
			body: JSON.stringify({ questionAnswerSides: questionAnswerSides }),
		}
	)
		.then(function (response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function (data) {
			return data
		})
}

/**
 * Get image answers associated with the case
 *
 * @param {number} id - case ID
 * @returns {*} - response containing list of images associated with the case
 */
export const fetchCaseImages = (id) => {
	return authenticatedFetch(`/api/case/${id}/images`, { method: 'get' })
		.then(function (response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function (images) {
			return images
		})
}

/**
 * Mark image as viewed to remove the "New" indication
 *
 * @param {number} id - image ID
 * @returns {*} - response indicating if the action was successful
 */
export const markImageAsRead = (id) => {
	return authenticatedFetch(`/api/case/images/${id}/markAsRead`, { method: 'put' })
		.then(function (response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function (images) {
			return images
		})
}